import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateAccountGroupsRequestModel, UpdateAccountGroupsResponseModel } from "@/features/accounts/account-group/services/update-account-groups-model";

export class UpdateAccountGroupsApi {
  /**
   * 口座グループ更新
   */
  public updateAccountGroups = async (
    param: UpdateAccountGroupsRequestModel
  ): Promise<UpdateAccountGroupsResponseModel> => {
    const path = `/api/accountgroups`;
    const res = await ApiClient.instance.put<UpdateAccountGroupsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
